import { Link } from 'react-router-dom';
import type { Product } from '@/mocks/products';

interface ProductCardProps {
  product: Product;
  showCategory?: boolean;
}

export default function ProductCard({ product, showCategory = false }: ProductCardProps) {
  const discounted = product.originalPrice > product.price;
  const discountPercent = Math.round((1 - product.price / product.originalPrice) * 100);

  return (
    <Link
      to={`/category/${encodeURIComponent(product.category)}`}
      className="block group cursor-pointer"
      data-product-shop
    >
      <div className="relative overflow-hidden rounded-lg bg-background-100 aspect-square mb-3">
        <img
          src={product.imageUrl}
          alt={product.name}
          title={`${product.name} | 久久精品品质甄选`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        {discounted && (
          <div className="absolute top-3 left-3 bg-accent-500 text-background-50 text-xs font-medium px-2 py-1 rounded-md">
            -{discountPercent}%
          </div>
        )}
        {!product.inStock && (
          <div className="absolute inset-0 bg-background-950/40 flex items-center justify-center">
            <span className="text-background-50 text-sm font-medium">暂时缺货</span>
          </div>
        )}
      </div>

      {showCategory && (
        <span className="text-xs text-secondary-600 font-medium mb-1 block">{product.category}</span>
      )}

      <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1 mb-1">
        {product.name}
      </h3>

      <p className="text-xs text-foreground-500 line-clamp-1 mb-2">{product.description}</p>

      <div className="flex items-center gap-2">
        <span className="text-base font-semibold text-foreground-950">
          &yen;{product.price.toLocaleString()}
        </span>
        {discounted && (
          <span className="text-xs text-foreground-400 line-through">
            &yen;{product.originalPrice.toLocaleString()}
          </span>
        )}
      </div>

      <div className="flex items-center gap-1 mt-1.5">
        <div className="flex items-center text-xs text-primary-500">
          {Array.from({ length: 5 }).map((_, i) => (
            <i
              key={i}
              className={`text-[10px] ${i < Math.floor(product.rating) ? 'ri-star-fill' : 'ri-star-line'}`}
            ></i>
          ))}
        </div>
        <span className="text-xs text-foreground-400">({product.reviewCount})</span>
      </div>
    </Link>
  );
}